import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import {Amplify, Auth} from 'aws-amplify';
import {cognito} from '../../../../environments/environment';
import {AppUser} from "@data/schema/account/app-user";
import {CommonConstant} from "@services/common-constant";

export interface IUser {
  email: string;
  password: string;
  showPassword: boolean;
  code: string;
  name: string;
  fullName : string;
  confirmPassword : string;
}

@Injectable({
  providedIn: 'root',
})
export class CognitoService {

  private authenticationSubject: BehaviorSubject<any>;
  private  appUserBehaviorSubject: BehaviorSubject<AppUser> = new BehaviorSubject<AppUser>(null);
  private  idtokenBehaviorSubject: BehaviorSubject<string> = new BehaviorSubject<string>(null);

  constructor(private commonConstants : CommonConstant) {
    Amplify.configure({
      Auth: cognito,
    });

    this.authenticationSubject = new BehaviorSubject<boolean>(false);
  }
  public signUp(user: IUser): Promise<any> {
    return Auth.signUp({
      username: user.email,
      password: user.password,
    });
  }

  public confirmSignUp(user: IUser): Promise<any> {
    return Auth.confirmSignUp(user.email, user.code);
  }

  public signIn(user: IUser): Promise<any> {
    return Auth.signIn(user.email, user.password)
      .then(() => {
        this.authenticationSubject.next(true);
      });
  }

  public signOut(): Promise<any> {
    return Auth.signOut()
      .then(() => {
        this.authenticationSubject.next(false);
      });
  }

  public isAuthenticated(): boolean {
    return this.authenticationSubject.value;
  }

  public getUser(): Promise<any> {
    return Auth.currentUserInfo();
  }

  getUserToken() {

     return Auth.currentUserPoolUser()
      .then((cognitoUser: any) => {
         return cognitoUser.signInUserSession.idToken.jwtToken;
      });

  }
  public forgotPassword(user:IUser): Promise<any> {
    return Auth.forgotPassword(user.email);
  }


  public updateUser(user: IUser): Promise<any> {
    return Auth.currentUserPoolUser()
      .then((cognitoUser: any) => {
        return Auth.updateUserAttributes(cognitoUser, user);
      });
  }

  public  removeUserData(){
      localStorage.removeItem('IRVING_FUND_TOKEN');
      localStorage.removeItem('APP-USER')
  }
  public getAppUser(): AppUser{
    //return this.appUserBehaviorSubject.getValue();
    return localStorage.getItem('APP-USER') ? JSON.parse(localStorage.getItem('APP-USER')) : null;
  }
  public setAppUser(appUser: AppUser){
    //return this.appUserBehaviorSubject.next(appUser);
   return localStorage.setItem('APP-USER',JSON.stringify(appUser));
  }

  public forgotPasswordSubmit(user:IUser): Promise<any>{
    return Auth.forgotPasswordSubmit(user.email,user.code,user.password);
  }
  tokenExpired(token: string) {
    const expiry = (JSON.parse(atob(token.split('.')[1]))).exp;
    return (Math.floor((new Date).getTime() / 1000)) >= expiry;
  }
  getIDToken() {
    //return this.idtokenBehaviorSubject.getValue();
   return localStorage.getItem('IRVING_FUND_TOKEN');
  }
  setIDToken(token: string) {
    //return this.idtokenBehaviorSubject.next(token);
    localStorage.setItem('IRVING_FUND_TOKEN',token);

  }
  isTokenExpired(){
    const token = this.getIDToken();
    if(token) {
      return this.tokenExpired(token);
    }
     return true;
  }
  refreshToken(){
    return Auth.currentAuthenticatedUser()
      .then((user: any) => {
        return user.refreshSession(user.signInUserSession.refreshToken);
      });
  }

}
